import React, { useEffect, useState } from "react";
import { BrandFetchApi } from "../../ApiCalls/Brands";
import { Link, useParams } from "react-router-dom";

const Brand = () => {
  const [brands, setBrands] = useState([]);
  const { id } = useParams(); // Extract the brand ID from the URL parameters

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await BrandFetchApi();
        if (response?.Status === "1" && response?.Data) {
          setBrands(response.Data);
        }
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };

    fetchBrands();
  }, []);

  return (
    <>
      {brands.length > 0 ? (
        <div className="p-5 w-full">
          <h1 className="text-2xl font-medium">Brands</h1>
          <div className="flex w-full overflow-x-auto">
            <ul className="flex gap-5 py-5">
              {brands.map((brand) => (
                <Link to={`/brands/${brand.id}`} key={brand.id} state={{ brand }}>
                  <li
                    className={`border-2 w-max hover:scale-110 transition-transform ease-in-out duration-300 p-2 m-2 rounded-lg cursor-pointer border-gray-400  ${id === String(brand.id) ? "border-4 border-green-500 scale-105 " : ""
                      }`}
                  >
                    <img
                      src={brand.image || "default-image-path.png"}
                      alt={brand.brandname || "Brand Image"}
                      style={{ width: "90px", height: "90px" }}
                      className="object-contain"
                    />
                  </li>
                </Link>
              ))}
            </ul>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Brand;
